module.exports = __webpack_public_path__ + "account/assets/course.9b78e1ae.svg";